import { faBuildingColumns } from '@fortawesome/pro-solid-svg-icons';
import { Typography } from '@mui/material';

import CheckboxField from '../../components/CheckboxField/CheckboxField';
import Description from '../../components/Description/Description';
import Group from '../../components/Group/Group';
import IconWithText from '../../components/IconWithText/IconWithText';
import MonetaryField from '../../components/MonetaryField/MonetaryField';
import RadioField from '../../components/RadioField/RadioField';
import Title from '../../components/Title/Title';
import { useAppSelector } from '../../hooks';
import useTranslation from '../../hooks/useTranslation';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';

const AccountInfoPageSE = () => {
    const translate = useTranslation();

    const paymentMethod = useAppSelector(selectFieldStateByName)('paymentMethod')?.value;

    /**
     * TODO:
     * add if samla lån ui
     */

    return (
        <>
            <Title text={translate('page.account-information.title')} />
            <Description text={translate('page.account-information.description')} />
            <RadioField
                name="paymentMethod"
                options={[
                    { id: 'MY_ACCOUNT', label: translate('field.account-information.option.my-account') },
                    { id: 'OTHER_ACCOUNT', label: translate('field.account-information.option.other-account') },
                ]}
            />
            {paymentMethod === 'OTHER_ACCOUNT' ? (
                <Group>
                    <MonetaryField
                        name="payoutAccountClearingNumber"
                        label={translate('field.account-information.account-clearing-number')}
                    />
                    <MonetaryField
                        name="payoutAccountNumber"
                        label={translate('field.account-information.account-number')}
                    />
                </Group>
            ) : (
                <IconWithText icon={faBuildingColumns} text="Placeholder for bank, accountnumber.." />
            )}
            <CheckboxField name="paymentAutogiro" label={translate('field.account-information.direct-debit')} />
            <Typography variant="body2">{translate('page.account-information.body-text')}</Typography>
        </>
    );
};

export default AccountInfoPageSE;
